<template>
  <div class="sc-message--buttons">
    <button
      v-for="(button, index) in message.data.buttons"
      :key="index"
      class="sc-message--buttons-content"
      @click.stop="handleClick($event, button)"
      :style="{borderColor: colors.button.border, color: colors.button.text, backgroundColor: colors.button.bg }"
    >{{ button.title }}</button>
  </div>
</template>

<script>
export default {
  name: "ButtonsMessage",
  inject: {
    chat: {
      type: Object
    },
    settings: {
      type: Object
    },
    colors: {
      type: Object
    }
  },
  props: {
    message: {
      required: true
    }
  },
  methods: {
    handleClick(event, button) {
      if (button.type === "web_url" && button.url) {
        if (button.messenger_extensions) {
          this.chat.webviewUrl = button.url;
        } else {
          window.open(button.url, "_blank");
        }
      } else if (button.type === "postback") {
        this.chat.payload = {text: button.title, payload: button.payload};
        this.chat.send = {
          event,
          source: "post-back",
          data: {
            type: "postback",
            data: {
              text: button.title,
              payload: button.payload
            }
          }
        };
        this.settings.autoFlush && (this.chat.payload = null);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sc-message--button {
  border: 0px;
  padding: 0px;
}
.sc-message--buttons {
  color: rgb(34, 34, 34);
  max-width: -webkit-fill-available;
  padding: .25rem .5rem;
  border-radius: 6px;
  font-weight: 300;
  font-size: 1.25rem;
  line-height: 1.4;
  position: relative;
  -webkit-font-smoothing: subpixel-antialiased;
  text-align: center;
}
.sc-message--buttons-content {
  border: 1px solid;
  border-radius: 20px;
  padding: .25rem;
  width: 80%;
  margin: 2px;
  cursor: pointer;
  outline: 0;
}
.sc-message--list-element-bottom {
  .sc-message--buttons-content {
    width: 100%;
    font-weight: 600;
    border-radius: 0 0 6px 6px;
    padding: .5rem;
    margin: 0;
  }
  .sc-message--buttons {
    padding: 0;
  }
}
.sc-message--list-element {
  .sc-message--buttons-content {
    padding: 0.5rem;
    margin: 0;
  }
  .sc-message--buttons {
    padding: 0;
    margin: 1rem;
    text-align: center;
  }
}
.sc-message--carousel-element {
  .sc-message--buttons-content {
    padding: 0.5rem;
  }
  .sc-message--buttons {
    margin: 0;
    text-align: center;
  }
}
</style>
